/**
 * Created by r4zi4l on 05.04.2024
 */

const EnergyRewardType = {
    currency: true,
    controls: "MenuBarLivesItem",
    flyingAnimation: Reward.JUMP_COLLECT_ANIMATION,
    target: "energy",

    getIcon: function () {
        return cleverapps.skins.getSlot("reward_energy_png") || bundles.reward_icons.frames.reward_energy_png;
    },

    getSmallIcon: function () {
        return cleverapps.skins.getSlot("energy_small_png") || bundles.reward_icons.frames.energy_small_png;
    },

    receive: function (value, options) {
        cleverapps.lives.give(value, options.event, true);
        return cleverapps.pendingRewards.add("lives", value, () => {
            cleverapps.lives.processRegenerateState(true);
            cleverapps.lives.trigger("changeAmount");
        });
    }
};

// energy games receive { lives: N } configs as energy; with the lives feature on, lives is a separate type (features/src/lives/livesrewards.js)
if (!cleverapps.config.features.includes("lives")) {
    Reward.register("lives", {
        ...EnergyRewardType,

        getPrice: function (value) {
            return Reward.LIVES_PRICE * value;
        }
    });
}

Reward.register("energy", {
    ...EnergyRewardType,

    getFlyingAmount: function (amount) {
        return Math.min(5, Math.floor(amount / 5) + 1);
    },

    getPrice: function (value) {
        return 1.59 * value;
    }
});

const getExpeditionEnergyIcon = function (slotName, fallback) {
    const locationId = LivesHelper.GetActiveOwnLivesLocationId();
    const skin = locationId !== undefined && cleverapps.SkinManager.SKINS[`${locationId}_expedition`];
    const slot = skin && skin.slots[slotName];
    return (typeof slot === "function" ? slot() : slot) || fallback;
};

Reward.register("expeditionEnergy", {
    currency: true,
    flyingAnimation: Reward.JUMP_COLLECT_ANIMATION,

    getPrice: function (value) {
        return RewardTypes.energy.getPrice(value);
    },

    getIcon: function () {
        return getExpeditionEnergyIcon("reward_energy_png", bundles.reward_icons.frames.reward_energy_png);
    },

    getSmallIcon: function () {
        return getExpeditionEnergyIcon("energy_small_png", bundles.reward_icons.frames.energy_small_png);
    },

    receive: function (value, options) {
        LivesHelper.ListActiveOwnLivesLocationIds().forEach((locationId) => {
            LivesHelper.GiveTo(locationId, value, options.event);
        });
    }
});
